import { useState } from 'react';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './components/LoginPage';
import CalendarPage from './components/CalendarPage';
import ReportsPage from './components/ReportsPage';
import './index.css';

const NAV_ICONS = {
  calendar: (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  reports: (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
};

function App() {
  const { user, loading, logout } = useAuth();
  const [page, setPage] = useState('calendar');

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--dartom-green-dark)' }}>
      <div style={{ color: 'white', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 24, fontWeight: 700 }}>Ładowanie...</div>
    </div>
  );

  if (!user) return <LoginPage />;

  const PAGE_TITLES = {
    calendar: 'Kalendarz Urlopowy',
    reports: 'Zestawienia',
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="sidebar-logo-top">DARTOM</div>
          <div className="sidebar-logo-sub">Transport Sukcesu</div>
        </div>

        <nav className="sidebar-nav">
          <div className={`nav-item ${page === 'calendar' ? 'active' : ''}`} onClick={() => setPage('calendar')}>
            {NAV_ICONS.calendar}
            Kalendarz
          </div>
          {user.role === 'manager' && (
            <div className={`nav-item ${page === 'reports' ? 'active' : ''}`} onClick={() => setPage('reports')}>
              {NAV_ICONS.reports}
              Zestawienia
            </div>
          )}
        </nav>

        <div className="sidebar-user">
          <div className="sidebar-user-name">{user.name}</div>
          <div className="sidebar-user-role">{user.role === 'manager' ? 'Manager' : 'Pracownik'}</div>
          <button className="logout-btn" onClick={logout}>Wyloguj się</button>
        </div>
      </aside>

      <main className="main-content">
        <div className="topbar">
          <span className="topbar-title">{PAGE_TITLES[page]}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {user.role === 'manager' && (
              <span className="badge" style={{ background: '#eaf4e6', color: '#2d6a1f', fontSize: 12 }}>Manager</span>
            )}
            <span style={{ fontSize: 13, color: 'var(--text3)' }}>{user.email}</span>
          </div>
        </div>

        <div className="page-body">
          {page === 'calendar' && <CalendarPage user={user} />}
          {page === 'reports' && user.role === 'manager' && <ReportsPage user={user} />}
        </div>
      </main>
    </div>
  );
}

export default App;
